
import React from 'react';
import { format } from 'date-fns';
import { Globe } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Company } from '@/lib/types';

interface CompanyDetailsInfoProps {
  company: Company;
}

const CompanyDetailsInfo = ({ company }: CompanyDetailsInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Company Information</CardTitle>
        <CardDescription>Basic details about {company.name}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {company.industry && (
          <div>
            <h3 className="text-sm font-medium">Industry</h3>
            <p>{company.industry}</p>
          </div>
        )}
        
        {company.size && (
          <div>
            <h3 className="text-sm font-medium">Company Size</h3>
            <Badge variant="outline">{company.size}</Badge>
          </div>
        )}
        
        {company.website && (
          <div>
            <h3 className="text-sm font-medium">Website</h3>
            <a 
              href={company.website} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-blue-500 hover:underline flex items-center"
            >
              <Globe className="h-4 w-4 mr-2" />
              {company.website}
            </a>
          </div>
        )}
        
        <div>
          <h3 className="text-sm font-medium">Created</h3>
          <p>{format(new Date(company.created_at), "PPP")}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default CompanyDetailsInfo;
